<template>
  <div>
    <div id="filtro_listagem" class="filtros" style="width: auto; float:right;">
      <label v-if="!iscategoria">
        <select v-model="selected.filtro1" id="filtro1" class="filtro-select" @change="limpaFiltrosFilhos(1)">
          <option value="">Segmento</option>
          <option v-for="(categoria, idx) in leilao.categorialeilao" :key="idx" :value="categoria.categorialeilao_id">{{
              categoria.nm_categoria
            }}
          </option>
        </select>
      </label>
      <label>
        <select v-model="selected.filtro2" id="filtro2" class="filtro-select filtro-select-ds"
                @change="limpaFiltrosFilhos(2)">
          <option value="">{{ filtros.filtro1_nome ? filtros.filtro1_nome : 'Selecionar' }}</option>
          <option v-if="(iscategoria || selected.filtro1) && nome" v-for="(nome, idx) in filtroCache['1']" :key="idx"
                  :value="idx">{{ nome }}
          </option>
        </select>
      </label>
      <label>
        <select v-model="selected.filtro3" id="filtro3" class="filtro-select filtro-select-ds"
                @change="limpaFiltrosFilhos(3); clearCacheFiltro(4); filtroCache.change = true;"
                :disabled="!enable.filtro3 && !selected.filtro2">
          <option value="">{{ filtros.filtro2_nome ? filtros.filtro2_nome : 'Selecionar' }}</option>
          <option v-if="(iscategoria || selected.filtro1) && marca" v-for="(marca, idx) in filtroCache3" :key="idx"
                  :value="idx">{{ marca }}
          </option>
        </select>
      </label>
      <label v-if="filtros.filtro3">
        <select v-model="selected.filtro4" id="filtro4" class="filtro-select filtro-select-ds"
                @change="limpaFiltrosFilhos(4)" :disabled="!selected.filtro3">
          <option value="">{{ filtros.filtro3_nome ? filtros.filtro3_nome : 'Selecionar' }}</option>
          <option v-if="(iscategoria || selected.filtro1) && modelo" v-for="(modelo, idx) in filtroCache['4']"
                  :key="idx" :value="idx">{{ modelo }}
          </option>
        </select>
      </label>
      <label v-if="filtros.filtro4">
        <select v-model="selected.filtro5" id="filtro5" class="filtro-select" :disabled="!selected.filtro4">
          <option value="">{{ filtros.filtro4_nome ? filtros.filtro4_nome : 'Selecionar' }}</option>
          <option v-if="(iscategoria || selected.filtro1) && modelo" v-for="(modelo, idx) in filtros.filtro4" :key="idx"
                  :value="idx">{{ modelo }}
          </option>
        </select>
      </label>
      <div @click="limpaFiltrosFilhos(1)" class="refresh-btn fa fa-trash filtro-clear" title="Limpar filtros!"></div>
    </div>
    <div style="clear:both;"></div>
  </div>
</template>
<script>
export default {
  props: ['leilao', 'filtros', 'iscategoria', 'loadfiltro'],
  data() {
    return {
      selected: {
        filtro1: '',
        filtro2: '',
        filtro3: '',
        filtro4: '',
        filtro5: '',
      },

      enable: {
        filtro2: false,
        filtro3: false,
        filtro4: false,
      },

      filtroCache: {
        1: {},
        3: {},
        4: {},
        change: false
      }
    }
  },
  methods: {
    getIdFromUrl(param) {
      const currentUrl = window.location.href;
      const parts = currentUrl.split('/');
      const index = parts.indexOf(param);
      if (index !== -1 && index + 1 < parts.length) {
        const value = parts[index + 1];
        return value.split('?')[0];
      }
      return null;
    },

    habilita(selectAtual, selectHabilitar) {
      const proximoSelect = document.getElementById(selectHabilitar)
      if (document.getElementById(selectAtual).value.trim() !== '') {
        proximoSelect.disabled = false
      } else {
        this.selected[selectHabilitar] = ''
        proximoSelect.disabled = true

      }

      if (selectAtual === 'filtro1') {
        document.querySelectorAll('.filtro-select-ds').forEach((item) => {
          if (document.getElementById(selectAtual).value.trim() == '') {
            item.disabled = true
          }
        })
        this.selected.filtro2 = ''
        this.selected.filtro3 = ''
        this.selected.filtro4 = ''
        this.selected.filtro5 = ''
      }
    },
    checkSegmento() {
      if (this.getIdFromUrl('leilao_id') == 17486) {
        console.log(this.getIdFromUrl('leilao_id'));
        this.selected.filtro1 = 3;
      } else {
        if (this.leilao.categorialeilao) {
          if (this.leilao.categorialeilao.length === 1) {
            this.selected.filtro1 = this.leilao.categorialeilao[0].categorialeilao_id
          }
        }
      }
    },

    // quando trocar o filtro pai os filhos serão resetados
    limpaFiltrosFilhos(filtroNum) {
      filtroNum++
      for (let i = filtroNum; i <= 5; i++) {
        this.selected[`filtro${i}`] = '';
      }
      if (this.selected.filtro1 === '') {
        this.selected.filtro2 = '';
        this.selected.filtro3 = '';
        this.selected.filtro4 = '';
        this.selected.filtro5 = '';
      }
    },

    clearCacheFiltro(indx) {
      this.filtroCache[indx] = {}
      this.filtroCache4()
    },

    filtroCache4() {
      if (this.filtroCache.change || Object.values(this.filtroCache["4"]).length === 0) {
        this.filtroCache["4"] = Object.assign({}, this.filtros.filtro3) || {}
        this.filtroCache.change = false
      }
    }
  },
  watch: {
    selected: {
      handler(novoObj, antigoObj) {
        this.$parent.$emit('filtroChange', novoObj)
      },
      deep: true
    },
    loadfiltro: function () {
      if (this.loadfiltro === true) {
        this.checkSegmento()
      }
    },
    filtros: {
      handler(value) {
        this.filtroCache[1] = Object.assign({}, value.filtro1);

        this.filtroCache[3] = Object.assign({}, value.filtro2);

        this.filtroCache[4] = Object.assign({}, value.filtro3);

        this.filtroCache.change = false;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    filtroCache3() {
      return this.filtros.filtro2 || {}
    }
  },
  created() {
    // console.log('leilao_id ===> ' + this.getIdFromUrl('leilao_id'));
  }
}
</script>
<style scoped>
/* STYLE SELECT */
label {
  position: relative;
  display: inline-block;
}

label:before {
  content: '';
  height: 31px;
  position: absolute;
  right: 7px;
  top: 3px;
  width: 22px;
  background: #fff;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  pointer-events: none;
  display: block;
}

label:after {
  content: " ";
  position: absolute;
  right: 15px;
  top: 46%;
  margin-top: -3px;
  z-index: 2;
  pointer-events: none;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6.9px 4px 0 4px;
  border-color: #aaa transparent transparent transparent;
  pointer-events: none;
}

label select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 0 30px 0 10px;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  line-height: 36px;
  height: 36px;
  background: #fff;
  margin: 0 5px 5px 0;
}

select::-ms-expand {
  display: none;
}

#filtro_listagem {
  float: right !important;
}

.filtro-select {
  max-width: 150px;
}

@media (max-width: 535px) {

  .filtro-select,
  label {
    width: 100%;
  }

  .filtro-select {
    max-width: auto;
  }

  #filtro_listagem {
    position: relative;
    height: 182px;
  }
}

@media (max-width: 768px) {
  .filtro-select {
    max-width: 100%;
  }
}

.filtro-clear {
  padding-top: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/shared/Filtro.vue